//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectFace.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"DistanceTolerance",1,0],[1,"Face",0,"SelectFace",0],[0,"IsApplyToAll",1,0],[0,"IsKeepParameterization",1,0],[0,"IsReverseDirection",1,0],[0,"Method",1,0],[1,"OffsetAtA",0,"Expression",0],[1,"OffsetAtB",0,"Expression",0],[1,"OffsetAtC",0,"Expression",0],[1,"OffsetAtD",0,"Expression",0],[0,"PointA",1,"Point",0],[0,"PointB",1,"Point",0],[0,"PointC",1,"Point",0],[0,"PointD",1,"Point",0]],[],[]];
SPLM.Features.VariableOffsetBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VariableOffsetBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VariableOffsetBuilder.MethodOptions = Object.freeze({
    "Linear" : "Linear", "Cubic" : "Cubic"});

export default SPLM;